<script setup>
import { ref } from "vue";
import { __ } from '@/utils';
import Modal from "@components/modal.vue";
import IconUnavailable from "@components/icons/icon-unavailable.vue";
import IconSmartphone from '@components/icons/icon-smartphone.vue';

const props = defineProps(['esimNumbers', 'selectedNumber', 'isActive']);
const emit = defineEmits(['close', 'submit']);

const currentNumber = ref(null);

const handleSubmit = () => {
    emit('close');
    emit('submit', currentNumber.value);
}

</script>

<template>
    <Modal :isActive="isActive" @close="$emit('close')" class="no-head-border smaller">
		<template #body>
            <div class="popup-image">
                <IconUnavailable />
            </div>
			<h3>
				<strong><span class="red-text">{{ __('Please note') }}</span> {{ __('line') }}</strong> {{ selectedNumber.number }} {{ __('is currently unavailable') }}
			</h3>
			<p>{{ __('The national mobility system operates on Sunday-Thursday at 08:00-21:00 and on Friday and holiday evening at 08:00-13:30. You can return during business hours and perform the process.') }}</p>
			<h4>{{ __('Select a different subscription to activate') }}</h4>
            <div class="number-boxes" v-if="esimNumbers?.length">
                <div class="number-box" v-for="number in esimNumbers" :key="number.number">
                    <button
                        type="button"
                        class="pill pill--iflex"
                        :class="{'is-clicked': currentNumber === number}"
                        v-if="!number.active"
                        @click="currentNumber = number"
                    >
                        <span class="pill__inner">
                            <span>{{ number.number }}</span>
                            <div class="pill__icon">
                                <IconSmartphone />
                            </div>
                        </span>
                    </button>
                </div>
            </div>
            <button
                type="button"
                class="btn btn--arrows w149"
                :disabled="!currentNumber"
                @click="handleSubmit"
            >{{ __('Continued') }}</button>
		</template>
	</Modal>
</template>